export default __webpack_public_path__ + "static/media/add.b1f3c9bd.svg";